export default __webpack_public_path__ + "3e60aa046d80b516203cca9dea8732b3.ttf";